import r from "./index953.js";
function t(e, n) {
  var f = r(e.buffer);
  return new e.constructor(f, e.byteOffset, e.length);
}
export {
  t as default
};
